import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Route guard that checks if the user is authenticated.
 * Redirects to login page if not authenticated.
 */
export const authGuard: CanActivateFn = (): boolean | UrlTree => {
    const authService = inject(AuthService);
    const router = inject(Router);


    if (authService.isLoggingOut) {
        return router.parseUrl('/session-expired');
    }

    // Check if user is authenticated
    if (authService.isAuthenticated) {
        return true;
    }

    // Store URL for redirect after login
    const attemptedUrl = window.location.pathname + window.location.search;
    if (attemptedUrl && attemptedUrl !== '/auth/login') {
        localStorage.setItem('redirectUrl', attemptedUrl);
    }

    // If not authenticated, redirect to login
    return router.parseUrl('/auth/login');
};
